import { useDeviceStore } from '@shared/global-store/stores/device/device'
import { useMediaQuery } from '@vueuse/core'

export const useIsScreenLg = () => {
  const deviceStore = useDeviceStore()

  return useMediaQuery(`(min-width: ${deviceStore.screens.lg}px)`, {
    ssrWidth: deviceStore.screenWidthGuess,
  })
}

export const useIsScreenMd = () => {
  const deviceStore = useDeviceStore()

  return useMediaQuery(`(min-width: ${deviceStore.screens.md}px)`, {
    ssrWidth: deviceStore.screenWidthGuess,
  })
}

export const useIsScreenSm = () => {
  const deviceStore = useDeviceStore()

  return useMediaQuery(`(min-width: ${deviceStore.screens.sm}px)`, {
    ssrWidth: deviceStore.screenWidthGuess,
  })
}

export const useIsScreenXs = () => {
  const deviceStore = useDeviceStore()

  return useMediaQuery(`(max-width: ${deviceStore.screens.sm - 1}px)`, {
    ssrWidth: deviceStore.screenWidthGuess,
  })
}

export const useIsScreenSmMax = () => {
  const deviceStore = useDeviceStore()

  return useMediaQuery(`(max-width: ${deviceStore.screens.md - 1}px)`, {
    ssrWidth: deviceStore.screenWidthGuess,
  })
}
